/*
 * AG Cart: free-shipping progress + add-ons (sections/ag-cart-boost.liquid).
 * Fills the empty [data-ag-cb-mount] elements in the mini-cart and on the cart page.
 * All amounts come pre-rendered from Liquid; this file only fetches, swaps HTML and adds items.
 * It reuses the theme's own cart events: it listens for "cartupdated" and dispatches it after an add,
 * which makes the existing Alpine mini-cart refresh its items, count and subtotal.
 */
(function () {
  if (window.AGCartBoost) return;

  var SECTION = 'ag-cart-boost';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var controller = null;
  var timer = null;
  var lastAnnounce = null;
  var pending = {};
  var uid = 0;

  function $all(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  function announce(text) {
    if (!text) return;
    $all('[data-ag-cb-live]').forEach(function (el) {
      el.textContent = '';
      setTimeout(function () { el.textContent = text; }, 60);
    });
  }

  // Copy the parts of a rendered section into every mount that allows them.
  function apply(src, opts) {
    if (!src) return;
    opts = opts || {};
    // If focus is inside a mount, park it on the mount itself before its content is replaced.
    // Removing a focused element would otherwise move focus to <body>, which closes the theme's dropdown mini-cart.
    var active = document.activeElement;
    var holder = active && active.closest ? active.closest('[data-ag-cb-mount]') : null;
    var dropdown = holder && holder.closest('.w-dropdown');
    if (holder) { holder.setAttribute('tabindex', '-1'); holder.focus({ preventScroll: true }); }
    var surfaces = {
      progress: (src.getAttribute('data-progress-surfaces') || '').split(/\s+/),
      addons: (src.getAttribute('data-addon-surfaces') || '').split(/\s+/)
    };
    $all('[data-ag-cb-mount]').forEach(function (mount) {
      var part = mount.getAttribute('data-ag-cb-mount');
      var tpl = src.querySelector('template[data-part="' + part + '"]');
      var allowed = tpl && surfaces[part] && surfaces[part].indexOf(mount.getAttribute('data-surface')) > -1;
      if (!allowed) { mount.innerHTML = ''; mount.hidden = true; return; }
      var prefix = 'agcb' + (++uid);
      mount.innerHTML = tpl.innerHTML.replace(/__AGCB__/g, prefix);
      mount.hidden = false;
    });
    var now = document.activeElement;
    var parked = (holder && (now === holder || now === document.body || !now)) || (opts.focusAddons && (now === document.body || !now));
    if (parked) {
      var visible = function (el) { return el.getClientRects().length; };
      var scope = dropdown || document;
      var target = $all('[data-ag-cb-mount="addons"]:not([hidden]) .ag-cb-addons__heading', scope).filter(visible)[0] ||
        $all('[data-ag-cb-mount="progress"]:not([hidden]) .ag-cb-progress__msg', scope).filter(visible)[0] ||
        (dropdown && $all('.nav_dropdown-close-button', dropdown).filter(visible)[0]);
      if (target) {
        if (!target.hasAttribute('tabindex') && target.tagName !== 'BUTTON') target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }
    if (holder) holder.removeAttribute('tabindex');
    var msg = src.getAttribute('data-announce') || '';
    var parts = [];
    if (opts.added) parts.push(opts.added + ' added to your cart.');
    if (opts.announce && msg && msg !== lastAnnounce) parts.push(msg);
    if (parts.length) announce(parts.join(' '));
    lastAnnounce = msg;
  }

  function parse(html) {
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    return doc.querySelector('[data-ag-cb-src]');
  }

  function onCartPage() { return !!document.querySelector('[data-ag-cb-mount][data-surface="page"]'); }

  function cartSectionId() {
    var mount = document.querySelector('[data-ag-cb-mount][data-surface="page"]');
    var wrap = mount && mount.closest('[id^="shopify-section-"]');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }

  // Re-render this section (and on the cart page, the cart section) from the current cart.
  function refresh(opts) {
    opts = opts || {};
    if (controller) controller.abort();
    controller = new AbortController();
    var ids = [SECTION];
    var pageId = opts.withCartPage ? cartSectionId() : null;
    if (pageId) ids.push(pageId);
    return fetch(root + 'cart?sections=' + ids.join(','), { signal: controller.signal })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        controller = null;
        if (pageId && data[pageId]) {
          var wrap = document.getElementById('shopify-section-' + pageId);
          var fresh = new DOMParser().parseFromString(data[pageId], 'text/html').getElementById('shopify-section-' + pageId);
          if (wrap && fresh) wrap.replaceWith(fresh);
        }
        apply(parse(data[SECTION]), opts);
        return true;
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return false;
        // Leave the last good state in place; checkout is never blocked.
        if (window.console) console.warn('AG cart add-ons: refresh failed', e);
        return false;
      });
  }

  function schedule(opts) {
    clearTimeout(timer);
    timer = setTimeout(function () { refresh(opts); }, 180);
  }

  function setError(card, text) {
    var el = card && card.querySelector('[data-ag-cb-error]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  function add(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled || btn.getAttribute('aria-busy') === 'true' || pending[id]) return;
    var card = btn.closest('.ag-cb-card');
    var title = btn.getAttribute('data-title') || 'Item';
    var label = btn.textContent;
    pending[id] = true;
    // aria-disabled (not disabled) keeps keyboard focus on the button while the request runs.
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('aria-busy', 'true');
    var hadFocus = document.activeElement === btn;
    btn.textContent = 'Adding…';
    setError(card, '');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) {
            var err = new Error(data.description || data.message || 'Could not add this item.');
            err.userMessage = data.description || data.message;
            throw err;
          }
          return data;
        });
      })
      .then(function () {
        // The theme's mini-cart listens for this and reloads items, count and subtotal.
        window.dispatchEvent(new CustomEvent('cartupdated', { detail: { source: 'ag-cart-boost' } }));
        return refresh({ announce: true, withCartPage: onCartPage(), focusAddons: hadFocus, added: title })
          .then(function (ok) {
            if (ok) return;
            // Added, but the panel could not be re-rendered: say so and leave the button usable.
            announce(title + ' added to your cart.');
            if (document.contains(btn)) {
              btn.removeAttribute('aria-disabled');
              btn.removeAttribute('aria-busy');
              btn.textContent = label;
            }
          });
      })
      .catch(function (e) {
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        var text = e && e.userMessage ? e.userMessage : 'Couldn’t add this item. Please try again.';
        setError(card, text);
        announce(text);
      })
      .then(function () { delete pending[id]; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ag-cb-add]');
    if (btn) { e.preventDefault(); add(btn); return; }
    // Load as soon as the mini-cart is opened.
    if (e.target.closest && e.target.closest('[li-element="mini-cart-toggle"]')) schedule();
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-ag-cb-select]');
    if (!sel) return;
    var card = sel.closest('.ag-cb-card');
    var btn = card.querySelector('[data-ag-cb-add]');
    var opt = sel.options[sel.selectedIndex];
    var ok = sel.value && opt && !opt.disabled;
    btn.disabled = !ok;
    if (ok) btn.setAttribute('data-variant-id', sel.value); else btn.removeAttribute('data-variant-id');
    var price = card.querySelector('[data-ag-cb-price]');
    if (price && ok && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
    setError(card, '');
  });

  // Prefetch on hover/touch of the cart icon.
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target.closest && e.target.closest('[li-element="mini-cart-toggle"]') && !document.querySelector('[data-ag-cb-mount][data-surface="drawer"]:not([hidden])')) schedule();
    }, { passive: true, capture: true });
  });

  // Any cart change made by the theme (add to cart, quantity, remove).
  window.addEventListener('cartupdated', function (e) {
    if (e.detail && e.detail.source === 'ag-cart-boost') return;
    // On /cart the mini-cart is also present: keep the server-rendered cart list in step with it.
    schedule({ announce: true, withCartPage: onCartPage() });
  });

  // Back/forward cache: the cart may have changed in another tab or page.
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });

  function init() {
    var local = document.querySelector('#shopify-section-' + SECTION + ' [data-ag-cb-src]');
    if (local) apply(local);
    else if (document.querySelector('[data-ag-cb-mount][data-surface="drawer"]')) {
      var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
      idle(function () { refresh(); });
    }
  }

  window.AGCartBoost = { refresh: refresh, apply: apply };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
